import { faUser as faUserClosed } from '@fortawesome/pro-duotone-svg-icons';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClickAwayListener, IconButton, IconButtonProps, lighten, MenuItem, styled } from '@mui/material';
import { FC, useCallback, useContext, useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import AuthContext from '../../contexts/auth/AuthContext';
import Dropdown from '../common/Dropdown';


const StyledIconButton = styled(IconButton, { shouldForwardProp: props => props !== "open"})<IconButtonProps & { open?: boolean }>(({ theme, open }) => ({
    minHeight: '40px', 
    maxHeight: '40px', 
    maxWidth: '40px',
    minWidth: '40px', 
    backgroundColor: lighten("#252423ff", 0.3),
    margin: '0 6px',
    borderRadius: open ? 
        '50% 50% 0 0' :
        '50%',

    "&:hover": {
        backgroundColor: theme.palette.primary.main,
        boxShadow: '0 0px 3px 2px rgba(0,0,0,0.12), 0 0px 2px rgba(0,0,0,0.24)'
    },

    "&:active": {
        backgroundColor: theme.palette.secondary.main
    }
}));

interface IProfileDropdownProps {
    
}

const ProfileDropdown: FC<IProfileDropdownProps> = ({
    
}) => {
    const navigate = useNavigate();
    const { user, logout } = useContext(AuthContext);

    const [profileOpen, setProfileOpen] = useState<boolean>(false);
    const profileAnchor = useRef<HTMLButtonElement>(null);

    const handleLogout = useCallback(async () => {
        await logout();
        navigate("/");
    }, [navigate, logout]);

    return (
        <ClickAwayListener
            onClickAway={() => setProfileOpen(false)}
        > 
            <StyledIconButton 
                open={profileOpen}
                color="primary"
                disableRipple 
                ref={profileAnchor}
                onClick={() => setProfileOpen(c => !c)}
            >
                {
                    user ? 
                        <FontAwesomeIcon color='white' fontSize='1.2rem' icon={faUserClosed} /> :
                        <FontAwesomeIcon color='white' fontSize='1.2rem' icon={faUser} />
                }

                <Dropdown
                    anchor={profileAnchor.current}
                    open={profileOpen}
                >
                    {
                        user ?
                            <>
                                {/* <MenuItem onClick={() => navigate(`/profile`)}>Profile</MenuItem> */}
                                <MenuItem onClick={handleLogout}>Log Out</MenuItem>
                            </> :
                            <>
                                <MenuItem onClick={() => navigate(`/admin/login`)}>Log In</MenuItem>
                            </>
                    }
                    
                </Dropdown>
            </StyledIconButton>
        </ClickAwayListener>
    );
}

export default ProfileDropdown;